/**
 * K线图美国线
 */
import KLineState from '../kline'
import Util, {mergeModelData} from '../../util/index.js';
const model = {
  kline: {
    Type: Array,
    Default: () => ([])
  },
  close_px: {
    Type: Object,
    Default: () =>({})
  }
};
export default class KLineUSState extends KLineState {
  constructor({data, ...rest}) {
    super({...rest, data: mergeModelData(model, data)});
  }
  _drawMain() {
    const {
      left,
      bottom
    } = this.availArea;
    const ctx = this.context;
    const {kline} = this.state.data;
    // 这里进行美国线的绘制
    this._drawKlineUS(kline, left, bottom);
  }
  _drawTitle() {
    const ctx2 = this.curContext;
    const {current, sealObj} = this.state.data;
    const {height, top, baseSize} = this.state;
    const {ratioFixed} = sealObj;
    const {baseLine} = this.option.MainContext.title;
    const baseLineY = top + height * baseLine;
    let {left} = this.availArea;
    const data = this.state.data.close_px
    const {
      sizeRatio,
      fontFamily,
      color,
      space
    } = this.option.KLine.closePx;
    ctx2.font = sizeRatio * baseSize * this.dpr + 'px ' + fontFamily;
    ctx2.fillStyle = color;
    ctx2.textAlign = 'left';
    ctx2.textBaseline = 'middle';
    ctx2.beginPath();
    const item = data[current];
    if (Util.isDef(item) && Util.isValidNumber(item.value)) {
      const text = '收盘价: ' + item.value.toFixed(ratioFixed);
      const textWidth = ctx2.measureText(text).width;
      ctx2.fillText(text, left, baseLineY);
      left += textWidth;
    } else {
      const text = '收盘价: -';
      const textWidth = ctx2.measureText(text).width;
      ctx2.fillText(text, left, baseLineY);
      left += textWidth;
    }
    left += space * this.dpr;
  }
}